/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class DataSourceConfigurationModel {
        public dataSources: Wars.Domain.Model.DataSource[];
        public currentDataSource: Wars.Domain.Model.DataSource;
        public swaggerApiUrl: string;

        constructor(private dataSourceService: services.DataSourceService, private id: string,
            private $scope: angular.IScope, private codeService: services.ManageSystemCodesService,
            private $http: angular.IHttpService, private growl: angular.growl.IGrowlService,
            private $location:angular.ILocationService) {
            var self = this;


            dataSourceService.getDataSources(id).then(p => {
                self.dataSources = p;
            });
        }

        public addDataSource() {
            this.currentDataSource = this.dataSourceService.createNewEntity<Wars.Domain.Model.DataSource>("DataSource");
            this.currentDataSource.processConfiguration_id = this.id;
            this.dataSources.push(this.currentDataSource);
            this.save();
        }

        public save(callback?: any) {
            this.dataSourceService.saveAllChanges(callback);
        }

        public editDataSource(dataSource: Wars.Domain.Model.DataSource) {
            this.currentDataSource = dataSource;
        }

        private getDataOperationType(type: string): Wars.Domain.Model.Codes.Enums.DataOperationType {
            switch (type.toUpperCase()) {
                case "POST":
                    return Wars.Domain.Model.Codes.Enums.DataOperationType.Post;
                case "GET":
                    return Wars.Domain.Model.Codes.Enums.DataOperationType.Get;
                case "PUT":
                    return Wars.Domain.Model.Codes.Enums.DataOperationType.Put;
                case "DELETE":
                    return Wars.Domain.Model.Codes.Enums.DataOperationType.Delete;
                default:
                    return null;
            }
        }

        private getDataType(type: string): Wars.Domain.Model.Codes.Enums.VariableType {
            if (!type) {
                return Wars.Domain.Model.Codes.Enums.VariableType.String;
            }

            switch (type.toLowerCase()) {
                case "integer":
                    return Wars.Domain.Model.Codes.Enums.VariableType.Integer;
                case "number":
                    return Wars.Domain.Model.Codes.Enums.VariableType.Decimal;
                case "boolean":
                    return Wars.Domain.Model.Codes.Enums.VariableType.Boolean;
                case "array":
                    return Wars.Domain.Model.Codes.Enums.VariableType.List;
                case "string":
                    return Wars.Domain.Model.Codes.Enums.VariableType.String;
                default:
                    return Wars.Domain.Model.Codes.Enums.VariableType.Object;
            }
        }

        public addOperation() {
            var dataOp = this.dataSourceService.createNewDataOperation();
            dataOp.operationType = Wars.Domain.Model.Codes.Enums.DataOperationType.Get;
            dataOp.isArrayResult = false;
            dataOp.isTested = false;
            this.currentDataSource.operations.push(dataOp);
            this.save();
        }

        public operationUrlChanged(operation: warsApp.models.DataOperation) {
            var splitUrl = operation.url.split('/');
            var urlParameters = Enumerable.from(splitUrl).where(s => s[0] === ":" && !Enumerable.from(operation.parameters).any(p => p.name === s.substring(1)));

            urlParameters.forEach(p => {
                var parameter = this.dataSourceService.createNewDataOperationParameter();
                parameter.name = p.substring(1);
                parameter.parameterType = Wars.Domain.Model.Codes.Enums.VariableType.String;
                parameter.required = true;
                operation.parameters.push(parameter);
            });

            this.save();
        }

        public addParameter(operation: warsApp.models.DataOperation) {
            var parameter = this.dataSourceService.createNewDataOperationParameter();
            parameter.parameterType = Wars.Domain.Model.Codes.Enums.VariableType.String;
            parameter.required = false;
            operation.parameters.push(parameter);
            this.save();
        }

        public removeOperation(operation: warsApp.models.DataOperation) {
            operation.parameters.forEach(p => {
                p.entityAspect.setDeleted();
            });

            var self = this;
            this.save(() => {
                operation.entityAspect.setDeleted();
                self.save();
            });
        }

        public removeParameter(parameter: Wars.Domain.Model.DataOperationParameter) {
            parameter.entityAspect.setDeleted();
            this.save();
        }

        public testOperation(operation: warsApp.models.DataOperation) {

            var url = operation.url;
            var inlineParameter: Wars.Domain.Model.DataOperationParameter[] = [];

            if (operation.parameters) {
                operation.parameters.forEach(p => {
                    url = url.replace(":" + p.name, (<any>p).value);
                    inlineParameter.push(p);
                });

                if (inlineParameter.length < operation.parameters.length) {
                    url = url + "?";

                    Enumerable.from(operation.parameters).where(p => !Enumerable.from(inlineParameter).any(inlineParameter => inlineParameter.id == p.id)).forEach(p => {
                        url += p.name + "=" + (<any>p).value + ";";
                    });
                }
            }

            this.$http.post('./proxy', url).then(r => {
                operation.responseExample = JSON.stringify(r.data);

                var resultSchema: Wars.Domain.Model.ObjectSchema = null;
                var objToGetSchema: any = null;

                if (Array.isArray(r.data)) {
                    operation.isArrayResult = true;
                    objToGetSchema = r.data[0];
                } else {
                    objToGetSchema = r.data;
                }

                resultSchema = this.getObjectSchema(objToGetSchema, operation.name);
                operation.resultSchema = resultSchema;
                operation.isTested = true;

                this.currentDataSource.objectSchemas.push(resultSchema);
                this.save();
                this.growl.success("Operation Successfully Tested", { ttl: 5000 });
            }).catch(r => {
                console.error(r);
            });

        }

        private getObjectSchema(obj: any, operationName: string, parentProperty?:Wars.Domain.Model.SchemaProperty): Wars.Domain.Model.ObjectSchema {
            var name: string;

            if (obj.__type) {
                name = obj.__type;
            } else if (obj.$type) {
                name = obj.$type;
            } else {
                name = operationName.replace("\\s", "_") + "_Result";
            }

            var returnSchema = null;
            this.currentDataSource.objectSchemas.forEach(o => {
                if (o.name === name) {
                    returnSchema = o;
                }
            });

            if (returnSchema)
                return returnSchema;

            var objectSchema = this.dataSourceService.createNewObjectSchema();
            objectSchema.name = name;

            for (var propName in obj) {
                if (propName === "__type" || propName === "$type" || propName === "" || propName == null)
                    continue;

                var value = obj[propName];
                var property = this.dataSourceService.createNewSchemaProperty();
                if (value == null) {
                    property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.String;
                } else {
                    switch (typeof value) {
                        case 'number':
                            property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.Decimal;
                            break;
                        case 'string':
                            if (value.toUpperCase().startsWith("/DATE(")) {
                                property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.DateTime;
                            } else {
                                property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.String;
                            }
                            break;
                        case 'boolean':
                            property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.Boolean;
                            break;
                        case 'undefined':
                        case 'function':
                            continue;
                        case 'object':
                            //property.entityAspect.setDeleted();
                            //continue;
                            if (Array.isArray(value)) {
                                property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.List;
                            } else {
                                property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.Object;
                                if (value) {
                                    property.typeSchema = this.getObjectSchema(value, propName,property);
                                }

                                this.currentDataSource.objectSchemas.push(property.typeSchema);
                            }


                            break;
                        default:
                            property.propertyType = Wars.Domain.Model.Codes.Enums.VariableType.String;
                    }
                }

                property.name = propName;
                property.required = false;

                objectSchema.properties.push(property);
            }
            return objectSchema;
        }

        public deleteDataSource() {
            this.$http.delete('./datasource/' + this.currentDataSource.id);
            this.dataSources.remove(this.currentDataSource);
            //this.currentDataSource.entityAspect.setDeleted();
            //this.dataSourceService.saveChanges(new Array(this.currentDataSource));
            this.currentDataSource = null;
        }

        public importSwaggerApi() {
            var self = this;
            this.dataSourceService.parseSwaggerUrl(this.swaggerApiUrl).then(api => {
                console.info(api);
                if (api) {
                    for (var definitionName in api.definitions) {
                        var definition = api.definitions[definitionName];

                        var objectSchema = self.dataSourceService.createNewObjectSchema();

                        objectSchema.name = definitionName;
                        for (var propName in definition.properties) {
                            var property = definition.properties[propName];
                            var newProperty = self.dataSourceService.createNewSchemaProperty();

                            newProperty.name = propName;
                            newProperty.propertyType = self.getDataType(property.type);

                            if (definition.required && definition.required[propName]) {
                                newProperty.required = true;
                            } else {
                                newProperty.required = false;
                            }

                            if (property.enum) {
                                var enumCodeGroup = self.codeService.createNewSpecializedCodeGroup();
                                enumCodeGroup.groupName = propName;

                                var isSystemLevel = !this.currentDataSource.processConfiguration_id;
                                property.enum.forEach(e => {
                                    var code = self.codeService.createNewSystemCode(enumCodeGroup, isSystemLevel);

                                    code.shortDescription = e;
                                    code.isActive = true;

                                    enumCodeGroup.codes.push(code);
                                });

                                newProperty.codeGroup = enumCodeGroup;
                            }

                            objectSchema.properties.push(newProperty);
                        }

                        self.currentDataSource.objectSchemas.push(objectSchema);
                    }

                    for (var pathName in api.paths) {
                        var path = api.paths[pathName];
                        for (var typeName in path) {

                            var type = path[typeName];
                            var dataOp = self.dataSourceService.createNewDataOperation();

                            dataOp.url = api.host + api.basePath + pathName;
                            dataOp.operationType = self.getDataOperationType(typeName);
                            dataOp.description = type.summary;
                            //dataOp.responseExample = type.responses;
                            dataOp.isArrayResult = false;
                            dataOp.isTested = false;

                            if (!type.parameters)
                                continue;

                            type.parameters.forEach(parameter => {
                                var newParameter = self.dataSourceService.createNewDataOperationParameter();
                                newParameter.name = parameter.name;
                                newParameter.required = parameter.required;
                                newParameter.description = parameter.description;
                                newParameter.parameterType = self.getDataType(parameter.type);
                                if (parameter.schema && parameter.schema.$ref) {
                                    var schemaSplit = parameter.schema.$ref.split("/");
                                    var name = schemaSplit[schemaSplit.length - 1];

                                    newParameter.parmeterSchema = Enumerable.from(self.currentDataSource.objectSchemas).single(s => s.name === name);
                                }

                                dataOp.parameters.push(newParameter);
                            });

                            self.currentDataSource.operations.push(dataOp);
                        }
                    }
                    console.info(self.currentDataSource);
                    self.save();
                    self.$scope.$apply();

                }
            });
        }
    }
}